import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-header',
  templateUrl: './event-header.component.html',
  styleUrls: ['./event-header.component.scss']
})
export class EventHeaderComponent implements OnInit {

  @Input() logo: string;
  @Input() date: string;
  @Input() bgImg: string;
  @Input() bgImgHeight: string;

  constructor() { }

  ngOnInit(): void {
  }

}
